import React, { useEffect, useState } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { triggerNotification } from "../../component/message/Msg";

const AddEvent = () => {
  // ------------------------------------- Input Field state management -------------------------------
  const [formData, setFormData] = useState({
    evttime: "",
    evttitle: "",
    evtdetail: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ---------------------------------------------- create / add Event ----------------------------------------------------c
  // Function to create a new event
  const createeventhandle = async () => {
    try {
      if (
        !formData.evttime.trim() ||
        !formData.evttitle.trim() ||
        !formData.evtdetail.trim()
      ) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return; // Stop form submission
      }

      // Validate required fields before making the API request
      // fetch(`${config.host_url}event/${id ? decodeURIComponent(atob(id)) : ""}`, {
      //   method: `${id ? "PUT" : "POST"}`,
      //   headers: {
      //     "Content-Type": "application/json",
      //     token: token,
      //   },
      //   body: JSON.stringify({
      //     course_name: courseName,
      //     image_link: imageLinkValue,
      //   }),
      // })
      //   .then((response) => response.json())
      //   .then((data) => {
      //     // console.log("data : ", data);
      //     if (data.status === 200) {
      //       // Course created successfully

      //       triggerNotification("success", `Course ${id ? "updated" : "created"} successfully.`);

      //       // Reset form fields after successful creation
      //       setCourseName("");
      //       setImageLinkValue("");
      //       setCourseDuration("");
      //       setPrice("");
      //       setShortDescription("");
      //       setLongDescription("");
      //       setVideoLinkValue("");
      //       setSelectedVideoRadioId("videolink");
      //       setSelectedImageRadioId("imagelink");
      //       navigate("/viewcourses");
      //     } else if (data.status === 400) {
      //       // Handle validation errors
      //       triggerNotification("error", "Validation Error.");
      //     } else if (data.status === 401) {
      //       // Handle unauthorized (invalid token)
      //       triggerNotification("error", "Unauthenticated user");
      //     } else {
      //       // Handle other server errors
      //       triggerNotification("error", "Internal server error.");
      //     }
      //   })
      //   .catch((error) => {
      //     // Handle fetch error here
      //     console.error("Fetch error:", error);
      //   });
    } catch (error) {
      console.error("Error creating event:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the event."
      );
    }
  };

  return (
    <>
      <>
        <Breadcrumb txt="Manage Event" subpath={["Add Event"]} />
        {/* form view */}
        <div className="col-xxl">
          <div className="card mb-4">
            <div className="card-header d-flex align-items-center ">
              <h5 className="mb-0">Add Event</h5>
            </div>
            <div className="card-body">
              <form>
                {/* Event Time */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="datetime-local"
                    className="form-control"
                    name="evttime"
                    id="evttime"
                    placeholder="Event Time"
                    value={formData.evttime}
                    onChange={handleChange}
                  />
                  <label htmlFor="evttime"> Event Time</label>
                </div>
                {/* Event Title */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="evttitle"
                    id="evttitle"
                    placeholder="Event Title"
                    value={formData.evttitle}
                    onChange={handleChange}
                  />
                  <label htmlFor="evttitle">Event Title</label>
                </div>
                {/* Event Detail */}
                <div className="form-floating form-floating-outline mb-4">
                  <textarea
                    id="basic-default-message"
                    className="form-control"
                    name="evtdetail"
                    style={{ height: "200px" }}
                    placeholder="Event Detail"
                    value={formData.evtdetail}
                    onChange={handleChange}
                  />
                  <label htmlFor="evtdetail">Event Detail</label>
                </div>
                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={createeventhandle}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default AddEvent;
